import { render, staticRenderFns } from "./ProjectHome.vue?vue&type=template&id=b50121b0&scoped=true"
import script from "./ProjectHome.vue?vue&type=script&lang=js"
export * from "./ProjectHome.vue?vue&type=script&lang=js"
import style0 from "./ProjectHome.vue?vue&type=style&index=0&id=b50121b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50121b0",
  null
  
)

export default component.exports